<template>
    <div class="edit-field">
        <b-input v-if="editMode" v-model="newValue" v-on:keyup.enter="onButtonClick"/>
        <slot v-else v-bind:value="value">{{ value }}</slot>
        <b-button :icon-left="icon" @click="onButtonClick" :loading="isLoading" type="is-text" size="is-small"/>
    </div>
</template>

<script>
    export default {
        name: "EditField",
        data() {
            return {
                editMode: false,
                newValue: '',
                isLoading: false,
            }
        },
        computed: {
            icon() {
                if (this.editMode) {
                    return 'check';
                } else {
                    return 'pencil';
                }
            },
        },
        props: {
            value: String,
            onUpdate: Function,
        },
        methods: {
            async onButtonClick() {
                if (this.editMode) {
                    if (this.onUpdate) {
                        this.isLoading = true;
                        const result = await this.onUpdate(this.newValue);
                        this.isLoading = false;
                        if (result) this.editMode = false;
                    } else {
                        this.$emit('edit', this.newValue);
                        this.editMode = false;
                    }
                } else {
                    this.newValue = this.value;
                    this.editMode = true;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .edit-field {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
</style>